<template>
  <div>
    <div class="stepwizard">
      <div class="stepwizard-row setup-panel">
        <b-row>
          <b-col v-if="checkPermission(['F_ASSESSMENT', 'F_CANDIDATE_AGENCY'])" class="stepwizard-step">
            <a href="#" type="button" :class="[item === 1 ? activeClass : defaultClass]" @click="save('general-data')"><i class="mdi mdi-account"></i></a>
            <p><small>General data</small></p>
          </b-col>
          <b-col v-if="checkPermission(['F_CANDIDATE_AGENCY'])" class="stepwizard-step">
            <a href="#" type="button" :class="[item === 2 ? activeClass : defaultClass]" @click="save('curriculum')"><i class="mdi mdi-arrange-bring-forward"></i></a>
            <p><small>CVs</small></p>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: { type: Object, required: true, default: () => ({}) },
    save: { type: Function, default: () => ({}) },
    item: { type: Number, default: () => ({}) }
  },
  data() {
    return {
      activeClass: 'btn btn-success btn-circle',
      defaultClass: 'btn btn-light btn-circle'
    }
  },
  methods: {
    checkPermission(roles) {
      return roles.some((r) => this.user.userRoles.includes(r))
    }
  }
}
</script>